<sbb-title class="main-title">SBB Lyne Angular Component Library</sbb-title>

<ul class="label-group">
  <li>
    <sbb-chip-label color="charcoal">100+ Components</sbb-chip-label>
  </li>
  <li>
    <sbb-chip-label color="charcoal">Accessibility WCAG 2.2 Level AA</sbb-chip-label>
  </li>
  <li>
    <sbb-chip-label color="charcoal">Angular Support</sbb-chip-label>
  </li>
  <li>
    <sbb-chip-label color="charcoal">Open Source</sbb-chip-label>
  </li>
</ul>

<p>
  Build accessible, consistent and production-ready applications with Lyne components. Powered by
  the official SBB Design System and optimized for Angular.
</p>

<sbb-title level="2" class="sbb-screen-reader-only">Packages</sbb-title>

<sbb-action-group class="libraries">
  @for (packageEntry of packages | keyvalue; track $index) {
    <sbb-teaser
      alignment="below"
      [accessibilityLabel]="'Documentation of ' + packageEntry.value.name"
      [routerLink]="packageEntry.key"
    >
      <figure slot="image" class="sbb-figure">
        <picture>
          <source [srcset]="packageEntry.value.imageDark" media="(prefers-color-scheme: dark)" />
          <img [src]="packageEntry.value.image" [alt]="packageEntry.value.name" />
        </picture>
        <sbb-chip-label
          [color]="packageEntry.value.labelColor"
          class="sbb-figure-overlap-start-end"
        >
          {{ packageEntry.value.label }}
        </sbb-chip-label>
      </figure>
      <sbb-title level="3" slot="title">{{ packageEntry.value.name }}</sbb-title>
      {{ packageEntry.value.description }}
    </sbb-teaser>
  }
</sbb-action-group>

<sbb-action-group class="sbb-orientation-horizontal-from-small actions">
  <sbb-button-link routerLink="/angular">Get Started with lyne-angular</sbb-button-link>

  <sbb-secondary-button-link href="https://digital.sbb.ch/de/design-system/lyne/overview//">
    UX Documentation
  </sbb-secondary-button-link>
</sbb-action-group>

<div class="card-group">
  <sbb-card color="milk" class="sbb-card-spacing-xxs">
    <sbb-card-link routerLink="/angular/guides/how-to-update"> How to update guide </sbb-card-link>
    <sbb-title level="2" visualLevel="5">How to update</sbb-title>
    <p>
      If you are already using &#64;sbb-esta/lyne-angular and want to update to the next major
      version, follow our
      <sbb-link-static>how to update guide</sbb-link-static>.
    </p>
  </sbb-card>

  <sbb-card color="milk" class="sbb-card-spacing-xxs">
    <div class="links">
      <div>
        <sbb-title level="2" visualLevel="5">Links lyne-components</sbb-title>

        <sbb-link-list>
          <sbb-block-link href="https://github.com/sbb-design-systems/lyne-components">
            Github
          </sbb-block-link>
          <sbb-block-link
            href="https://github.com/sbb-design-systems/lyne-components/issues/new/choose"
          >
            Create issue
          </sbb-block-link>
          <sbb-block-link
            href="https://github.com/sbb-design-systems/lyne-components/blob/main/docs/CONTRIBUTING.md"
          >
            Contribution guide
          </sbb-block-link>
        </sbb-link-list>
      </div>
      <div>
        <sbb-title level="2" visualLevel="5">Links lyne-angular</sbb-title>

        <sbb-link-list>
          <sbb-block-link href="https://github.com/sbb-design-systems/lyne-angular">
            Github
          </sbb-block-link>
          <sbb-block-link
            href="https://github.com/sbb-design-systems/lyne-angular/issues/new/choose"
          >
            Create issue
          </sbb-block-link>
        </sbb-link-list>
      </div>
    </div>
  </sbb-card>
</div>
